import React, { useEffect, useState } from "react";
import CustomTable from "../Components/CustomTable";
import { getColumns } from "./../../utils/tableHeaders";
import { fetchTableData } from "./../../utils/fetchTableData";
import Loader from "react-loaders";

const GeneViewList = ({ closeAlert, operationDetails }) => {
  const [loader, setLoader] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    fetchData(page, rowsPerPage);
  }, [operationDetails, page, rowsPerPage]);

  const fetchData = async (currentPage, limit) => {
    setLoader(true);
    setErrorMessage("Loading...");
    try {
      const data = await fetchTableData(operationDetails, currentPage, limit);
      if (!data) {
        throw new Error("Failed to fetch data");
      }

      const firstKey = Object.keys(data)[0];
      if (Array.isArray(data[firstKey]) && data[firstKey].length === 0) {
        setErrorMessage("No data Found");
      } else {
        setTableData(getData(data));
      }
    } catch (error) {
      if (error.details) {
        setErrorMessage(error.details);
      } else {
        setErrorMessage("No records available");
      }
    } finally {
      setErrorMessage("");
      setLoader(false);
    }
  };

  const getData = (response) => {
    if (!response) return [];

    switch (operationDetails?.type) {
      case "Tumorigenesis":
        setTotalRows(response?.tumorigenesis?.pagination?.total)
        setPage(response?.tumorigenesis?.pagination?.page)
        setRowsPerPage(response?.tumorigenesis?.pagination?.pageSize)
        return response?.tumorigenesis?.data || [];
      case "Survival":
        setTotalRows(response?.survival?.pagination?.total)
        setPage(response?.survival?.pagination?.page)
        setRowsPerPage(response?.survival?.pagination?.pageSize)
        return response?.survival?.data || [];
      case "Proliferation":
        setTotalRows(response?.proliferation?.pagination?.total)
        setPage(response?.proliferation?.pagination?.page)
        setRowsPerPage(response?.proliferation?.pagination?.pageSize)
        return response?.proliferation?.data || [];
      case "Drug_Sensitivity":
        setTotalRows(response?.drug_sensitivity?.pagination?.total)
        setPage(response?.drug_sensitivity?.pagination?.page)
        setRowsPerPage(response?.drug_sensitivity?.pagination?.pageSize)
        return response?.drug_sensitivity?.data || [];
      case "Significant_Condition":
        const up_regulated = response?.significantGenes?.goodGenes
        const down_regulated = response?.significantGenes?.badGenes
        const combinedGenes = [...new Set([...up_regulated, ...down_regulated])].join(", ");

        if (operationDetails?.significantCondition === "any significant") {
          return [
            {
              genesType: "Unique Gene List",
              genesList: combinedGenes || "-",
            },
          ];
        }
        return [
          { genesType: "Upregulated Genes", genesList: up_regulated?.join(", ") || "-" },
          { genesType: "Downregulated Genes", genesList: down_regulated?.join(", ") || "-" },
        ];
      case "Centrality":
        setTotalRows(response?.centrality?.pagination?.total)
        setPage(response?.centrality?.pagination?.page)
        setRowsPerPage(response?.centrality?.pagination?.pageSize)
        return response?.centrality?.data;
      case "Pathway":
        setTotalRows(response?.pathways?.pagination?.total)
        setPage(response?.pathways?.pagination?.page)
        setRowsPerPage(response?.pathways?.pagination?.pageSize)
        return response?.pathways?.data;
      default:
        return [];
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  }
  const handleRowsPerPageChange = (newLimit) => {

    setRowsPerPage(newLimit);
    setPage(1);
    fetchData(1, newLimit);
  };

  return (
    <div>
      <div className="view-popup-header mb-3">
        {operationDetails.type.replace("_", " ")}
      </div>
      <div
        className={`popup-table-container ${loader ? "blur-content" : ""}`}
        style={{ backgroundColor: operationDetails?.type === "Significant_Condition" ? "" : "#F2F2F2" }}
      >
        <CustomTable
          columns={getColumns(operationDetails.type, operationDetails.centrality, false)}
          data={tableData}
          tableType={operationDetails?.type}
          errorMessage={errorMessage}
          totalRows={totalRows}
          rowsPerPage={rowsPerPage}
          currentPage={page}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
        />
      </div>

      <div className="button-popup-container" >
        <button
          className="btn btn-lg btn-primary btn-delete"
          onClick={closeAlert}
        >
          Cancel
        </button>
      </div>
      {loader && (
        <div className="backdrop">
          <Loader type="ball-pulse-rise" />
        </div>
      )}
    </div>
  );
};

export default GeneViewList;
